import SubscriptionPaymentContainer from "./SubscriptionPaymentContainer";
import SubscriptionPaymentStore from "./SubscriptionPaymentStore";

export default SubscriptionPaymentStore(SubscriptionPaymentContainer);